import { Edge } from "@vue-flow/core";

export const DEFAULT_MARKER_COLOR = "#492093";
export const SELECTED_MARKER_COLOR = "#46a1f1";
export const DETACHED_MARKER_COLOR = "#bcc5d0";

export function getEdgeMarkerColor(edge?: Edge): string {
  if (!edge) return DEFAULT_MARKER_COLOR;
  if (edge.hidden) return "transparent";
  return DEFAULT_MARKER_COLOR;
}
